export default __webpack_public_path__ + "static/logo_scroll-2234604fe17ff721ca6d4f4957c127a7.svg";